import React, { memo } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import { BusinessPartnerDevicesPage } from 'pages/BusinessPartnerManagement/BusinessPartnerDevicesManagement/BusinessPartnerDevicesPage';

export const BusinessPartnerDevicesManagement = memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute exact path={path} component={BusinessPartnerDevicesPage} />
    </Switch>
  );
});
